const ServiceTypeEnum = {
  GLOBAL: 'global',
  STORE : 'store'
}

export default ServiceTypeEnum
